import { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Projects from '../components/sections/Projects';
import Contact from '../components/sections/Contact';
import { scrollToSection } from '../utils/scrollUtils';

const HomePage = () => {
  useEffect(() => {
    // First check for sessionStorage flag (from direct navigation links)
    const sectionToScrollTo = sessionStorage.getItem('scrollToSection');
    
    if (sectionToScrollTo) {
      // Clear the flag immediately to prevent unintended scrolling on future page loads
      sessionStorage.removeItem('scrollToSection');
      
      // Delay scrolling to ensure all components are mounted
      setTimeout(() => {
        scrollToSection(sectionToScrollTo, true);
      }, 500);
    } 
    // Then check for hash-based navigation
    else {
      const hash = window.location.hash.substring(1);
      if (hash) {
        scrollToSection(hash, true);
      }
    }
  }, []);

  return (
    <Layout transparentHeader>
      <Hero />
      <About />
      <Projects />
      <Contact />
    </Layout>
  );
};

export default HomePage;
